import { useCallback, useRef, useState } from 'react'
import { api } from '@api'
import type { MealPlanDay } from '@hewey/shared'
import { addDaysIso, toIsoDate } from './dates.ts'

// How far back the hand-typed candidates are mined from.
const HISTORY_DAYS = 182

// Reads the household's older meal-plan days, once per visit. Kept out of
// `useResource` because that fetches on mount, and this is only wanted when
// select mode opens — early enough that Suggest doesn't have to wait for it.
// A failed fetch leaves the list empty and is retried on the next open;
// suggestions still work from the tagged recipes alone.
export const useMealHistory = () => {
	const [days, setDays] = useState<MealPlanDay[]>([])
	const started = useRef(false)

	const load = useCallback(() => {
		if (started.current) return
		started.current = true
		const today = toIsoDate(new Date())
		void api.mealPlan
			.list(addDaysIso(today, -HISTORY_DAYS), today)
			.then((r) => setDays(r.days))
			.catch(() => {
				started.current = false
			})
	}, [])

	return { days, load }
}
